import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";

const User = () => {
  const navigate = useNavigate();
  const [IsUserLoggedIn, setIsUserLoggedIn] = useState(false);
  useEffect(() => {
    getAuth().onAuthStateChanged((result) => {
      if (result == null) {
        setIsUserLoggedIn(false);
        // window.location.pathname = "/";
      } else {
        setIsUserLoggedIn(true);
      }
    });
  }, []);

  if (IsUserLoggedIn)
    return (
      <>
        <Header />
        <Sidebar />
        <Outlet />
      </>
    );
  // else return <HeroLoader />;
};

export default User;
